<template>
  <category-layout @changeLanguage="getItems">
    <categories :categories="categories"/>
  </category-layout>
</template>

<script>
import {mapGetters} from "vuex";
import categoryLayout from "../../components/dashboard/category/layout";
import Categories from "../../components/dashboard/category/categories";

export default {
  name: "Category",
  components: {categoryLayout, Categories},
  data() {
    return {};
  },
  mounted() {
    this.getItems()
  },
  computed: {
    ...mapGetters({
      categories: "Category/getFilteredCategories",
    }),
  },
  methods: {
    getItems() {
      this.$store.commit("Category/setCategories", {});
      this.$store.commit("Category/setFilteredCategories", {});
      this.$store.dispatch("Category/getDashboardCategories");
    }
  }
};
</script>
<style scoped>

</style>
